import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { supabase } from "./supabaseClient"; // Ensure you have a supabaseClient.js file for Supabase setup
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiTokenProvider } from "./Context/ApiTokenContext";
import { TimezoneProvider } from "./Context/TimezoneContext";
import Login from "./components/Login";
import Navbar from "./components/Navbar";
import Profile from "./components/Profile"; // Import the Profile component
import { AuthProvider, useAuth } from "./supabaseClient"; // Import AuthProvider and useAuth
import ChatBot from "./components/ChatBot";
import ChangePassword from "./components/ChangePassword"; // Import the ChangePassword component
import LoaderElement from "./components/common/Loader"; // Import the Loader component
import Privacy from "./components/common/PrivacyPolicy";
import TermsAndConditions from "./components/common/TermsAndConditions";
import FAQ from "./components/common/FAQ";
import PricingPage from "./components/common/PricingPage";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";

import Cookies from "js-cookie"; // Import Cookies
import icon from "./assets/favicon.png";
import Sidebar from "./components/sidebar/Sidebar"; // Import the Sidebar component
import UserProfile from "./UserProfile"; // Import the UserProfile component
import RightSidebar from "./components/sidebar/RightSidebar"; // Import the RightSidebar component
import Integrations from "./components/Integrations"; // Import the Integrations component
import BillingRedirect from "./components/billing/BillingRedirect";
import OnboardingModal from "./components/OnboardingModal"; // Import the OnboardingModal component
// import { FamilyJoinPage } from "./components/family"; // Import Family Join Page
// import FamilySlidePanel, { useFamilyPendingCount } from "./components/family/FamilySlidePanel"; // Import Family Slide Panel
import { storeChatHistory } from "./chatHistory"; // Import the createChatSession function
import { runBrodcasting, cleanupBroadcasting } from "./components/common/broadcasting"; // Import broadcasting functions
import { use } from "react";
import lightLogo from "./assets/Zlight.png"; // Import the logo image // Public folder is the root
import darkLogo from "./assets/Zdark.png"; // Import the logo image
import { WebSearchProvider } from "./components/webSearchContext";
import { VoiceProvider } from "./Context/VoiceContext";
import { MediaProvider } from "./Context/MediaContext";
import GlobalVoiceUI from "./components/GlobalVoiceUI";
import AppInstallBanner from "./components/common/AppInstallBanner";

function initializeTheme() {
  const savedTheme = Cookies.get("isDarkMode");
  return savedTheme ? savedTheme === "true" : false;
}

function initializeSidebarVisibility() {
  const savedVisibility = Cookies.get("isSidebarVisible");
  return savedVisibility ? savedVisibility === "true" : true;
}

function initializeSidebarNotificationVisibility() {
  const savedVisibility = Cookies.get("isSidebardNotificationVisible");
  return savedVisibility ? savedVisibility === "true" : false;
}

function App() {
  const { session, isLoading: authLoading } = useAuth();
  const currentUserId = session?.user?.id; // Add userId for filtering
  const [clearChatState, setClearChatState] = useState(() => () => {});
  const [setMessages, setSetMessages] = useState(() => () => {}); // Add state for setMessages
  const location = useLocation();
  const [isDarkMode, setIsDarkMode] = useState(initializeTheme());
  const [notifications, setNotifications] = useState([]);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(
    notifications.length,
  );

  // auto update variable
  const [categoryChannel, setCategoryChannel] = useState(0);
  const [ListCategoryChnnel, setListCategoryChannel] = useState(0);
  const [NotesCategoryChannel, setNotesCategoryChannel] = useState(0);

  const [taskChannel, setTaskChannel] = useState(0);
  const [notesChannel, setNotesChannel] = useState(0);
  const [listChannel, setListschannel] = useState(0);

  const [summary, setSummary] = useState(null);
  const [sideConvoChannel, setSideConvoChannel] = useState(0);
  const [notificationSessionChannel, setNotificationSessionChannel] =
    useState(0);

  const [activeSideConvoChannel, setActiveSideConvoChannel] = useState(0);
  const [activeChatBot, setActiveChatBot] = useState(0);
  const [TaskProfileChannel, setTaskProfileChannel] = useState(0);
  const [ListProfileChannel, setListProfileChannel] = useState(0);
  const [NotesProfileChannel, setNotesProfileChannel] = useState(0);
  const [QueueResponse, setQueueResponse] = useState(0);
  const [MeetingResponse, setMeetingResponse] = useState(0);
  const [ZoomeyCall, setZoomeyCall] = useState(0);
  const [OpenReminder, setOpenReminder] = useState(0);
  const [OpenMeeting, setOpenMeeting] = useState({ trigger: 0, meetingId: null });
  const [OpenSettings, setOpenSettings] = useState(0);
  const [OpenGrocery, setOpenGrocery] = useState(0);
  const [OpenQueue, setOpenQueue] = useState(0);
  const [OpenVoiceHistory, setOpenVoiceHistory] = useState(0);
  const [OpenScratchpad, setOpenScratchpad] = useState(0);
  const [OpenNotification, setOpenNotification] = useState(0);
  const [OpenScheduledTasks, setOpenScheduledTasks] = useState(0);
  const [notificationResponse, setNotificationResponse] = useState(0);
  const [ChatEventChannel, setChatEventChannel] = useState(0);
  const [ResetSessionBtn, setResetSessionBtn] = useState(0);

  const [chatSessionActivated, setChatSessionActivated] = useState(false);

  const [resetBroadcasting, setResetBroadcasting] = useState(0);
  const [queueRequests, setQueueRequests] = useState([]);
  const [queueRefreshKey, setQueueRefreshKey] = useState(0);

  const [queuePopup, setQueuePopup] = useState(0);

  const subscriptionRef = useRef(null);

  // Voice chat state
  const [isVoiceActive, setIsVoiceActive] = useState(false);
  const [isVoiceVideoEnabled, setIsVoiceVideoEnabled] = useState(false); // Camera/screen active
  const [isVoiceScreenSharing, setIsVoiceScreenSharing] = useState(false); // Screen share vs camera
  const [voiceConversationHistory, setVoiceConversationHistory] = useState([]);
  const [voiceSessionDuration, setVoiceSessionDuration] = useState(0);
  const [showVoiceTab, setShowVoiceTab] = useState(false); // Controls Voice tab visibility
  const [shouldSwitchToVoiceTab, setShouldSwitchToVoiceTab] = useState(false); // Trigger to auto-switch
  const voiceTimerRef = useRef(null);
  const voiceControlRef = useRef(null); // Ref for controlling Voice Assistant from ChatBot Z button

  const [isSidebarVisible, setIsSidebarVisible] = useState(
    initializeSidebarVisibility(),
  ); // Add state for sidebar visibility
  const [isSidebardNotificationVisible, setIsSidebarNotificationVisible] =
    useState(initializeSidebarNotificationVisibility()); // Add state for sidebar visibility

  const [queueModalData, setQueueModalData] = useState(null);
  const [uiContext, setUiContext] = useState({ current_view: 'To Do List' });

  // Family Pack panel state
  const [familyPanelOpen, setFamilyPanelOpen] = useState(false);
  // const familyPendingCount = useFamilyPendingCount();

  // Onboarding state
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [userDisplayName, setUserDisplayName] = useState(null);

  const handleOpenQueueModal = (queueId, queueTitle) => {
    setQueueModalData({ queueId, queueTitle });
  };
  useEffect(() => {
    // console.log("from app Suummary",summary)
  }, [summary]);
  useEffect(() => {
    const count = notifications.filter(
      (notification) => !notification.queuerequestid && !notification.is_read,
    ).length;
    setUnreadNotificationsCount(count);
  }, [notifications]);

  const handleMainSessionClick = async () => {
    Cookies.remove("chat_session_id"); // Remove the chat_session_id cookie
    // navigate('/chat-bot');
    window.location.reload(); // Navigate to the chat-bot route
  };

  // const toggleTheme = () => {
  //   setIsDarkMode((prev) => {
  //     const newMode = !prev;
  //     Cookies.set("isDarkMode", newMode.toString(), { expires: 365 });
  //     document.body.classList.toggle("dark-mode", newMode);
  //     return newMode;
  //   });
  // };
  useEffect(() => {
    document.body.setAttribute("data-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prev) => {
      const newMode = !prev;
      Cookies.set("isDarkMode", newMode.toString(), { expires: 365 });
      document.body.setAttribute("data-theme", newMode ? "dark" : "light");
      return newMode;
    });
  };

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => {
      const newVisibility = !prev;
      Cookies.set("isSidebarVisible", newVisibility.toString(), {
        expires: 365,
      });
      return newVisibility;
    });
  };

  const toggleSidebarNotification = () => {
    setIsSidebarNotificationVisible((prev) => {
      const newVisibility = !prev;
      Cookies.set("isSidebardNotificationVisible", newVisibility.toString(), {
        expires: 365,
      });
      return newVisibility;
    });
  };

  const handleNotificationUpdate = (updatedNotification = null) => {
    if (updatedNotification) {
      // Update specific notification in state
      setNotifications(prev =>
        prev.map(n => n.id === updatedNotification.id ? updatedNotification : n)
      );
    } else {
      // Just trigger re-render with functional update to avoid stale closure
      setNotifications(prev => [...prev]);
    }
  };

  // Removed: Unnecessary 5-second artificial loading delay that was causing slow page loads
  // The loader now only shows during actual auth loading (authLoading state)

  useEffect(() => {
    // alert("open")
  }, [queuePopup]);

  // Close right sidebar when navigating to userprofile
  useEffect(() => {
    if (location.pathname === "/userprofile") {
      setIsSidebarNotificationVisible(false);
    }
  }, [location.pathname]);

  // Check onboarding state when session is loaded
  const API_URL = process.env.REACT_APP_ZOOMEY_API_URL || "http://localhost:3000";
  useEffect(() => {
    async function checkOnboardingState() {
      if (!session?.user?.id) return;

      try {
        const response = await fetch(`${API_URL}/api/user/profile?user_id=${session.user.id}`);
        const data = await response.json();

        if (data.success && data.profile) {
          // Check if onboarding is needed (pending state or no display_name)
          if (data.profile.onboarding_state === "pending" || !data.profile.display_name) {
            setShowOnboarding(true);
          } else {
            setUserDisplayName(data.profile.display_name);
          }
        } else if (data.needs_migration) {
          // Migration not run yet - check if display_name equivalent exists via Supabase
          const { data: profile } = await supabase
            .from("profiles")
            .select("name")
            .eq("id", session.user.id)
            .single();

          // If no display name, show onboarding
          if (!profile?.name || profile.name === session.user.email?.split("@")[0]) {
            setShowOnboarding(true);
          }
        }
      } catch (err) {
        console.error("[App] Error checking onboarding state:", err);
      }
    }

    checkOnboardingState();
  }, [session?.user?.id, API_URL]);

  // Handle onboarding completion
  const handleOnboardingComplete = (data) => {
    // data can be string (old format) or object { nickname, location, timezone }
    const displayName = typeof data === 'string' ? data : data?.nickname;
    setUserDisplayName(displayName);
    setShowOnboarding(false);
  };

  // Voice chat callbacks
  const handleVoiceStart = () => {
    setIsVoiceActive(true);
    setVoiceConversationHistory([]); // Clear old transcript for new session
    setVoiceSessionDuration(0);
    setShowVoiceTab(true); // Show Voice tab
    setShouldSwitchToVoiceTab(true); // Trigger auto-switch to Voice tab
    // Start session duration timer
    voiceTimerRef.current = setInterval(() => {
      setVoiceSessionDuration(prev => prev + 1);
    }, 1000);
  };

  const handleVoiceEnd = () => {
    setIsVoiceActive(false);
    setIsVoiceVideoEnabled(false);
    setIsVoiceScreenSharing(false);
    // Stop session duration timer
    if (voiceTimerRef.current) {
      clearInterval(voiceTimerRef.current);
      voiceTimerRef.current = null;
    }
    // Keep showVoiceTab true so transcript remains visible
  };

  const handleVoiceTranscriptUpdate = (history) => {
    setVoiceConversationHistory(history);
  };

  const handleCloseVoiceTab = () => {
    setShowVoiceTab(false);
    setShouldSwitchToVoiceTab(false);
  };

  // Reset auto-switch trigger after it's been consumed
  const handleVoiceTabSwitched = () => {
    setShouldSwitchToVoiceTab(false);
  };

  // Voice trigger functions - called from ChatBot Z button
  const handleTriggerVoice = (mode) => {
    // Immediately show Voice UI with "Connecting..." state
    setIsVoiceActive(true);
    setShowVoiceTab(true);
    setShouldSwitchToVoiceTab(true);
    
    if (voiceControlRef.current) {
      if (mode === 'audio') {
        voiceControlRef.current.startAudio();
      } else if (mode === 'webcam') {
        voiceControlRef.current.startWebcam();
        setIsVoiceVideoEnabled(true);
        setIsVoiceScreenSharing(false);
      } else if (mode === 'screen') {
        voiceControlRef.current.startScreen();
        setIsVoiceVideoEnabled(true);
        setIsVoiceScreenSharing(true);
      }
    }
  };

  const handleStopVoice = () => {
    if (voiceControlRef.current) {
      voiceControlRef.current.stop();
    }
    setIsVoiceVideoEnabled(false);
    setIsVoiceScreenSharing(false);
  };

  // Stop only video/screen share (keep voice active)
  const handleStopVoiceVideo = () => {
    if (voiceControlRef.current) {
      voiceControlRef.current.stopVideoOnly();
    }
    setIsVoiceVideoEnabled(false);
    setIsVoiceScreenSharing(false);
  };

  // Cleanup voice timer on unmount
  useEffect(() => {
    return () => {
      if (voiceTimerRef.current) {
        clearInterval(voiceTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      runBrodcasting(
        currentUserId,
        session,
        location,
        setNotifications,
        showNotification,
        setMessages, // Ensure this is passed correctly
        setSummary,
        setCategoryChannel,
        setListCategoryChannel,
        setNotesCategoryChannel,
        setTaskChannel,
        setListschannel,
        setNotesChannel,
        setSideConvoChannel,
        setNotificationSessionChannel,
        setActiveSideConvoChannel,
        setActiveChatBot,
        setTaskProfileChannel,
        setListProfileChannel,
        setNotesProfileChannel,
        setChatEventChannel,
        subscriptionRef,
        setResetBroadcasting,
        setQueueResponse,
        setNotificationResponse,
        setMeetingResponse,
        setZoomeyCall,
        setOpenReminder,
        setOpenMeeting,
        setOpenSettings,
        setOpenGrocery,
        setOpenQueue,
        setOpenVoiceHistory,
        setOpenScratchpad,
        setOpenNotification,
        setOpenScheduledTasks,
        setResetSessionBtn,
        setChatSessionActivated,
      );
    }, 3000);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      cleanupBroadcasting(subscriptionRef);
    };
  }, [session, resetBroadcasting]);

  // Function to remove queue requests by session ID
  const removeQueueRequestsBySessionId = async (sessionId) => {
    if (!currentUserId) return;

    // 1. Remove from Supabase DB with user filter
    await supabase
      .from("queue_request")
      .delete()
      .eq("session_id", sessionId)
      .eq("user_id", currentUserId);

    // 2. Remove from state/UI
    setQueueRequests((prev) =>
      prev.filter((req) => req.session_id !== sessionId),
    );
  };

  // Function to show browser notification
  const showNotification = (title, message) => {
    if (Notification.permission === "granted") {
      try {
        new Notification(title, {
          body: message,
          icon: icon,
        });
      } catch (error) {
        console.error("Error showing notification:", error);
        // alert(`${title}\n\n${message}`);
      }
    } else {
      console.error("Notification permission not granted");
      // alert(`${title}\n\n${message}`);
    }
  };

  // Function to mark notification as read
  const markNotificationAsRead = async (id) => {
    if (!currentUserId) return;

    const { error } = await supabase
      .from("notifications")
      .update({ status: true }) // Update the status to true (read)
      .eq("id", id)
      .eq("user_id", currentUserId);

    if (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const clearNotifications = (updatedNotifications = []) => {
    setNotifications(updatedNotifications);
  };
  const clearChat = () => {
    // Add your clear chat logic here
    setClearChatState(true);
  };
  // Show loader while auth is being determined to prevent blank screen
  if (authLoading) {
    return <LoaderElement />;
  }

  const handleSidebarTabChange = (key) => {
    const viewMap = {
      "0": "To Do List",
      "1": "List (Grocery/Others)",
      "2": "Notes",
      "4": "Topics",
      "5": "Notifications",
      "8": "Grocery List"
    };
    setUiContext({ current_view: viewMap[key] || "Main Topic", active_tab: key });
  };

  return (
      <ApiTokenProvider>
    <AuthProvider>
      <TimezoneProvider userId={currentUserId}>
      <WebSearchProvider>
        <VoiceProvider userId={currentUserId} chatSessionId={Cookies.get("chat_session_id") || "main_session"}>
        <MediaProvider userId={currentUserId}>
        <AppInstallBanner />
        <div className="d-flex">
          {session && location.pathname === "/chat-bot" && (
            <>
              <div
                className={`col-3 sidebar leftSidebar ${
                  isSidebarVisible ? "" : "sidebar-hidden"
                }`}
                style={{
                  position: "fixed",
                  height: "100vh",
                  overflowY: "auto",
                  zIndex: 1,
                  padding: "0",
                  borderRight: "1px solid var(--border-color)",
                }}
              >
                <Sidebar
                  toggleTheme={toggleTheme}
                  isDarkMode={isDarkMode}
                  userId={session.user?.id}
                  isCategoryUpdate={categoryChannel}
                  isNotesCategoryUpdate={NotesCategoryChannel}
                  isListCategoryUpdate={ListCategoryChnnel}
                  isTaskChannelUpdate={taskChannel}
                  isListDataChannelUpdate={listChannel}
                  isNotesDataChannelUpdate={notesChannel}
                  isSideConvoChannelUpdate={sideConvoChannel}
                  isNotificationSessionChannel={notificationSessionChannel}
                  isActiveSideConvoChannel={activeSideConvoChannel}
                  isActiveCustomBotChannel={activeChatBot}
                  isTaskProfileChannel={TaskProfileChannel}
                  isListProfileChannel={ListProfileChannel}
                  isNotesProfileChannel={NotesProfileChannel}
                  isSidebarVisible={isSidebarVisible}
                  onTabChange={handleSidebarTabChange}
                  onVoiceStart={handleVoiceStart}
                  onVoiceEnd={handleVoiceEnd}
                  onVoiceTranscriptUpdate={handleVoiceTranscriptUpdate}
                  onVoiceVideoChange={(videoEnabled, isScreen) => {
                    setIsVoiceVideoEnabled(videoEnabled);
                    setIsVoiceScreenSharing(isScreen);
                  }}
                  voiceRef={voiceControlRef}
                  isVoiceActive={isVoiceActive}
                  onOpenReminder={() => setOpenReminder(prev => prev + 1)}
                  onOpenScheduledTasks={() => setOpenScheduledTasks(prev => prev + 1)}
                />
              </div>
              <button
                onClick={toggleSidebar}
                className="sidebar-toggle"
                style={{
                  // left: isSidebarVisible ? '25%' : '0px'
                  paddingLeft: isSidebarVisible ? "0px" : "8px",
                  paddingRight: isSidebarVisible ? "0px" : "8px",
                }}
              >
                {isSidebarVisible ? (
                  <i className="bi bi-chevron-left"></i>
                ) : (
                  <i className="bi bi-chevron-right"></i>
                )}
              </button>
            </>
          )}
          <div
            className={`${
              session && location.pathname !== "/reset-password"
                ? location.pathname === "/chat-bot"
                  ? isSidebarVisible
                    ? isSidebardNotificationVisible
                      ? "col-6 offset-3"
                      : "col-9 offset-3 NotificationSidebarIsVisable"
                    : isSidebardNotificationVisible
                      ? "col-9 sidebarIsVisable"
                      : "col-12 sidebarIsVisable NotificationSidebarIsVisable"
                  : isSidebardNotificationVisible
                    ? "col-9"
                    : "col-12"
                : "col-12"
            } `}
          >
            {session && location.pathname !== "/userprofile" && location.pathname !== "/integrations" && location.pathname !== "/reset-password" && (
              <Navbar
                onClearChat={clearChat}
                currentRoute={location.pathname}
                toggleTheme={toggleTheme}
                isDarkMode={isDarkMode}
                notifications={notifications}
                setNotifications={setNotifications}
                isSidebarVisible={isSidebarVisible}
                onOpenReminder={OpenReminder}
                onOpenMeeting={OpenMeeting}
                onOpenSettings={OpenSettings}
                onOpenGrocery={OpenGrocery}
                onOpenQueue={OpenQueue}
                onOpenVoiceHistory={OpenVoiceHistory}
                onOpenScratchpad={OpenScratchpad}
                onOpenNotification={OpenNotification}
                onOpenScheduledTasks={OpenScheduledTasks}
                familyPanelOpen={familyPanelOpen}
                setFamilyPanelOpen={setFamilyPanelOpen}
                familyPendingCount={0}
                userDisplayName={userDisplayName}
              />
            )}
            <div
              style={{
                background: "var(--background)",
                height: "100%",
                minHeight: "100vh",
              }}
            >
              <Routes>
                <Route
                  path="/login"
                  element={session ? <Navigate to="/chat-bot" /> : <Login />}
                />
                <Route
                  path="/forgot-password"
                  element={session ? <Navigate to="/chat-bot" /> : <ForgotPassword />}
                />
                <Route
                  path="/reset-password"
                  element={<ResetPassword />}
                />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/pricing" element={<PricingPage />} />

                <Route
                  path="/chat-bot"
                  element={
                    <ChatBot
                      setClearChat={clearChatState}
                      setSetMessages={setSetMessages}
                      toggleTheme={toggleTheme}
                      isDarkMode={isDarkMode}
                      notifications={notifications}
                      summary={summary}
                      ChatEventChannel={ChatEventChannel}
                      IsSidebardNotificationVisible={
                        isSidebardNotificationVisible
                      }
                      IsSidebarVisible={isSidebarVisible}
                      onSetLoading={() => {}}
                      onQueueSessionRemove={removeQueueRequestsBySessionId}
                      setQueueRefreshKey={setQueueRefreshKey}
                      onOpenQueueModal={handleOpenQueueModal}
                      onZoomeyCall={ZoomeyCall}
                      onResetSessionBtn={ResetSessionBtn}
                      onChatSessionActivated={chatSessionActivated}
                      userId={currentUserId}
                      userName={userDisplayName || session?.user?.user_metadata?.full_name || session?.user?.email?.split('@')[0] || null}
                      uiContext={uiContext}
                      onTriggerVoice={handleTriggerVoice}
                      onStopVoice={handleStopVoice}
                      onStopVoiceVideo={handleStopVoiceVideo}
                      isVoiceActive={isVoiceActive}
                      isVoiceVideoEnabled={isVoiceVideoEnabled}
                      isVoiceScreenSharing={isVoiceScreenSharing}
                    />
                  }
                />
                {/* <Route
                  path="/profile"
                  element={
                    <PrivateRoute>
                      <Profile
                        toggleTheme={toggleTheme}
                        isDarkMode={isDarkMode}
                        onSetLoading={() => {}}
                      />
                    </PrivateRoute>
                  }
                /> */}
                {/* <Route
                  path="/change-password"
                  element={
                    <PrivateRoute>
                      <ChangePassword onSetLoading={() => {}} />
                    </PrivateRoute>
                  }
                /> */}
                <Route
                  path="*"
                  element={<Navigate to={session ? "/chat-bot" : "/login"} />}
                />
                <Route path="/billing/success" element={<BillingRedirect type="success" />} />
                <Route path="/billing/cancel" element={<BillingRedirect type="cancel" />} />
                <Route
                  path="/userprofile"
                  element={
                    session ? (
                      <UserProfile
                        toggleTheme={toggleTheme}
                        isDarkMode={isDarkMode}
                      />
                    ) : (
                      <Navigate to="/login" />
                    )
                  }
                />
                <Route
                  path="/integrations"
                  element={
                    session ? (
                      <Integrations toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
                    ) : (
                      <Navigate to="/login" />
                    )
                  }
                />
                {/* <Route
                  path="/family/join/:token"
                  element={<FamilyJoinPage />}
                /> */}
              </Routes>
            </div>
          </div>
          {session && location.pathname !== "/reset-password" && (
            <>
              <div
                className={`col-3 offset-9 notification-scroll rightSidebar ${
                  isSidebardNotificationVisible ? "" : "sidebar-hidden"
                }`}
                style={{
                  position: "fixed",
                  height: "100vh",
                  // overflowY: "auto",
                  // zIndex: 1,
                  borderLeft: "1px solid var(--border-color)",
                  padding: "0",
                  background: "var(--background)",
                }}
              >
                <RightSidebar
                  clearNotifications={clearNotifications}
                  notifications={notifications}
                  onNotificationUpdate={handleNotificationUpdate}
                  onQueueResponse={QueueResponse}
                  onNotificationResponse={notificationResponse}
                  queueRequests={queueRequests}
                  setQueueRequests={setQueueRequests}
                  queueRefreshKey={queueRefreshKey}
                  setQueueRefreshKey={setQueueRefreshKey}
                  userId={session.user?.id}
                  queueModalData={queueModalData}
                  setQueueModalData={setQueueModalData}
                  onMeetingResponse={MeetingResponse}
                  IsSidebardNotificationVisible={isSidebardNotificationVisible}
                  // Voice chat props
                  isVoiceActive={isVoiceActive}
                  voiceConversationHistory={voiceConversationHistory}
                  voiceSessionDuration={voiceSessionDuration}
                  showVoiceTab={showVoiceTab}
                  shouldSwitchToVoiceTab={shouldSwitchToVoiceTab}
                  onCloseVoiceTab={handleCloseVoiceTab}
                  onVoiceTabSwitched={handleVoiceTabSwitched}
                />{" "}
                {/* Pass clearNotifications function */}
              </div>
              {/* Hide notification button on userprofile page */}
              {location.pathname !== "/userprofile" && (
                <button
                  onClick={toggleSidebarNotification}
                  className={
                    unreadNotificationsCount > 0
                      ? "sidebar-toggle-notification-count"
                      : "sidebar-toggle-notification"
                  }
                  style={{
                    // right: isSidebardNotificationVisible ? '25%' : '0px'
                    paddingLeft: isSidebardNotificationVisible ? "0px" : "10px",
                    paddingRight: isSidebardNotificationVisible ? "0px" : "10px",

                    right: "0%",
                  }}
                >
                  {isSidebardNotificationVisible ? (
                    <>
                      <i className="bi bi-chevron-right"></i>
                    </>
                  ) : (
                    <>
                      <i className="bi bi-bell-fill"></i>
                      {unreadNotificationsCount > 0 && (
                        <span
                          className="notification-count"
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            width: "20px",
                            height: "20px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {unreadNotificationsCount}
                        </span>
                      )}
                    </>
                  )}
                </button>
              )}
              {/* <button
                onClick={handleMainSessionClick}
                className={"sidebar-toggle-zoomey"}
                style={{
                  // right: isSidebardNotificationVisible ? '25%' : '0px'
                  paddingLeft: isSidebardNotificationVisible ? "4px" : "14px",
                  paddingRight: isSidebardNotificationVisible ? "1px" : "10px",
                  backgroundColor: isDarkMode ? "white" : "#18181B",
                  right: "0%",
                }}
              >
                <>
                  <img
                    src={isDarkMode ? darkLogo : lightLogo}
                    alt="Logo"
                    style={{
                      verticalAlign: "baseline",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </>
              </button> */}
            </>
          )}
          {session && <GlobalVoiceUI />}

          {/* Family Packs Slide Panel */}
          {/* {session && (
            <FamilySlidePanel
              isOpen={familyPanelOpen}
              onClose={() => setFamilyPanelOpen(false)}
            />
          )} */}

          {/* Onboarding Modal - shown on first login */}
          {session && (
            <OnboardingModal
              show={showOnboarding}
              onComplete={handleOnboardingComplete}
              userId={session.user?.id}
              userName={session.user?.user_metadata?.full_name}
            />
          )}
        </div>
        </MediaProvider>
        </VoiceProvider>
      </WebSearchProvider>
      </TimezoneProvider>
    </AuthProvider>
    </ApiTokenProvider>
  );
}

export default App;
